module.exports = __webpack_public_path__ + "img/car-mirrors.574e9e9d.svg";